export enum DocumentSize {
  small = 'SMALL',
  medium = 'MEDIUM',
  large = 'LARGE',
}
